import React from "react";
import MarketingShell, { Section } from "@/components/MarketingShell";

export default function Refund() {
  return (
    <MarketingShell title="Cancellation & Refund Policy" subtitle="Last updated June 2026">
      <p>We want you to be happy with Local CiteHub. This policy explains how cancellations and refunds work.</p>

      <Section heading="Cancel anytime">
        <p>You can cancel your subscription at any time from your account menu (Cancel membership). Cancellation stops future renewals immediately. You retain access to paid features until the end of your current billing period unless otherwise stated.</p>
      </Section>

      <Section heading="Refunds">
        <p>Recurring monthly charges are generally non-refundable once billed, because the service and listing work are delivered on an ongoing basis. If you believe you were charged in error, or you experienced a problem that prevented you from using the service, contact us within 14 days of the charge and we'll review your case in good faith.</p>
      </Section>

      <Section heading="One-time setup fees">
        <p>Where a plan includes a one-time setup fee, that fee covers onboarding work performed at signup and is non-refundable once the work has begun.</p>
      </Section>

      <Section heading="How to request">
        <p>Submit a request through the <a href="/contact" className="text-[#0055FF] font-semibold hover:underline">Contact page</a> with your account email and the charge date. We aim to respond within 1–2 business days.</p>
      </Section>
    </MarketingShell>
  );
}
